import React from "react";

const Button = ({
  children,
  size = "md",
  variant = "primary",
  type = "button",
  startIcon,
  endIcon,
  onClick,
  className = "",
  disabled = false,
}) => {
  // Size Classes — slimmer, more compact
  const sizeClasses = {
    sm: "px-3.5 py-2 text-xs",
    md: "px-4.5 py-2.5 text-xs",
  };

  // Variant Classes — monochrome
  const variantClasses = {
    primary:
      "bg-gray-900 text-white border border-gray-900 shadow-theme-sm hover:bg-gray-800 dark:bg-white dark:text-gray-900 dark:border-white dark:hover:bg-gray-100 disabled:bg-gray-300 disabled:border-gray-300 disabled:text-gray-500 dark:disabled:bg-gray-700 dark:disabled:border-gray-700 dark:disabled:text-gray-400",
    outline:
      "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 hover:text-gray-900 dark:bg-transparent dark:text-gray-300 dark:border-gray-700 dark:hover:bg-white/5 dark:hover:text-white",
  };

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center font-medium gap-1.5 rounded-lg transition-all duration-200 ${className} ${
        sizeClasses[size]
      } ${variantClasses[variant]} ${
        disabled ? "cursor-not-allowed opacity-50" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {startIcon && <span className="flex items-center">{startIcon}</span>}
      {children}
      {endIcon && <span className="flex items-center">{endIcon}</span>}
    </button>
  );
};

export default Button;
